import { RouterProvider } from 'react-router-dom';
import { AppProviders } from './app/providers';
import { router } from './app/router';
import { OfflineBanner } from '@/components/pwa/offline-banner';
import { UpdatePrompt } from '@/components/pwa/update-prompt';
import { UpdateNotice } from '@/components/pwa/update-notice';

export function App() {
  return (
    <AppProviders>
      {/*
       * These sit above the router rather than inside `AppShell`.
       *
       * The service worker is registered with `registerType: 'prompt'`, so a
       * new bundle waits for the user to accept it — and the login screen is
       * the one place a client can be pinned to an old bundle indefinitely,
       * because it is reachable without signing in. Registering the worker and
       * offering the update here means the login page always has a way to pick
       * up the current build (and the language/theme controls it ships).
       */}
      <OfflineBanner />
      <RouterProvider router={router} />
      <UpdatePrompt />
      {/*
       * Reports the outcome of an update the user accepted. It sits inside
       * `AppProviders` so it can raise a toast, and it renders nothing at all
       * for an ordinary load.
       */}
      <UpdateNotice />
    </AppProviders>
  );
}
